import { REVAMPED_SCREENS } from '../../../screens/user-flow/individual/revampedUserFlow/utils/constants';
import {
  CLEAR_STORE,
  RETRIEVE_USER_INFO,
  CHANGE_CURRENT_SCREEN,
  GET_NEW_ONBOARDING_ENABLED_USERS,
  REQUIRED_POA_DOCUMENTS,
  DOCUMENTS_CONDITIONS,
  SET_ATTEMPT_COUNT,
  MANUAL_DOCS_INFO,
  SET_USER_ADDRESS,
  SET_ADDRESS_PAGE_DATA_TOGGLE,
  SET_ADDRESS_PAGE_BACK_NAVIGATED,
  TOGGLE_MODAL_ERROR,
  SAVE_CURRENT_ONBOARDING_VERIFICATION_DOCUMENT,
  SET_EDITED_RETRIEVED_NAME,
  COLLECT_POA_TRULIOO,
  SET_KYC_REVIEW_DATA,
  SET_ONBOARDING_EKYC_CMS_DATA
} from '../../action-contants';

const INITIAL_STATE = {
  screens: [],
  currentScreen: REVAMPED_SCREENS.mobileNumberVerification,
  timeline: [],
  documentTimeLine: {},
  ackScreenShown: false,
  preSelectedPaymentMethod: null,
  userInfo: {
    firstName: '',
    lastName: ''
  },
  new_onboarding_enabled_users: false,
  required_poa_docs: [],
  addressRequired: false,
  identityRequired: false,
  isAddressVerifiedTrulioo: null,
  attemptCountFlag: false,
  manualDocInfo: null,
  isAddressPageHaveData: false,
  isAddressPageBackNavigated: false,
  addressInfo: {},
  errorModalState: {
    showModal: false,
    message: null
  },
  selectedDocument: {
    country_code: '',
    account_type: 'INDIVIDUAL',
    type: 'INDIVIDUAL_POA',
    is_back_required: false,
    is_mandatory: false,
    is_back_mandatory: false,
    fields_json: [],
    everification_meta: null,
    label: '',
    is_everification_required: false,
    is_kyc_oriented: true,
    show_upload_button: true,
    sequence: 1,
    rendering_sequence: 1,
    show_capture_button: false,
    company_entity_type_id: null,
    company_entity_type_code: null,
    document_code: '',
    document_description: '',
    document_input_type: 'FILE'
  },
  editedRetrievedName: {
    firstName: '',
    middleName: '',
    lastName: ''
  },
  reKycDetails: null,
  eKycCMSData: null
};

// eslint-disable-next-line
export default function userFlowReducer(state = INITIAL_STATE, action: any): any {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }

    case RETRIEVE_USER_INFO: {
      return {
        ...state,
        userInfo: action.data
      };
    }

    case CHANGE_CURRENT_SCREEN: {
      return {
        ...state,
        currentScreen: action.data
      };
    }

    case TOGGLE_MODAL_ERROR: {
      return {
        ...state,
        errorModalState: {
          showModal: action.data.showModal,
          message: action.data.message
        }
      };
    }
    case GET_NEW_ONBOARDING_ENABLED_USERS: {
      return {
        ...state,
        new_onboarding_enabled_users: action.data
      };
    }

    case REQUIRED_POA_DOCUMENTS: {
      return {
        ...state,
        required_poa_docs: action.data
      };
    }

    case DOCUMENTS_CONDITIONS: {
      return {
        ...state,
        addressRequired: action?.data?.addressRequired,
        identityRequired: action?.data?.identityRequired
      };
    }
    case SET_ATTEMPT_COUNT: {
      return {
        ...state,
        attemptCountFlag: action?.data
      };
    }

    case MANUAL_DOCS_INFO: {
      return {
        ...state,
        manualDocInfo: action.data
      };
    }

    case SET_ADDRESS_PAGE_DATA_TOGGLE: {
      return {
        ...state,
        isAddressPageHaveData: action.data
      };
    }

    case SET_ADDRESS_PAGE_BACK_NAVIGATED: {
      return {
        ...state,
        isAddressPageBackNavigated: action.data
      };
    }

    case SET_USER_ADDRESS: {
      return {
        ...state,
        addressInfo: action.data
      };
    }

    case SAVE_CURRENT_ONBOARDING_VERIFICATION_DOCUMENT: {
      return {
        ...state,
        selectedDocument: action.data
      };
    }
    case COLLECT_POA_TRULIOO: {
      return {
        ...state,
        isAddressVerifiedTrulioo: action.data
      };
    }

    case SET_EDITED_RETRIEVED_NAME: {
      return {
        ...state,
        editedRetrievedName: action.data
      };
    }

    case SET_KYC_REVIEW_DATA: {
      return {
        ...state,
        reKycDetails: action.data
      };
    }

    case SET_ONBOARDING_EKYC_CMS_DATA: {
      return {
        ...state,
        eKycCMSData: action.data
      };
    }

    default:
      return state;
  }
}
